import { Slide } from "react-reveal";

const HomeWhyChooseUs = () => {
  return (
    <section className="home-why section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600 section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">WHY CHOOSE US</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Why Choose NTUNA.COM<sup>&trade;</sup>
                </h2>
              </Slide>
              <p className="section-subtitle font-inter-regular">
                Organizations choose NTUNA.COM because we combine technical
                expertise, client-focused approach and proven experience to
                deliver reliable technology solutions that drive efficiency,
                growth and long-term success.
              </p>
            </div>
            <div className="section-body">
              <div className="why-content-container flex">
                <Slide left>
                  <div className="why-image-side">
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777811423/ntuna/why4_tmgoks.jpg"
                      alt="NTUNA.COM employees at work"
                    />
                    <div className="funfact-container">
                      <p className="funfact-title boldTitle">10+</p>
                      <span>years of experience</span>
                    </div>
                  </div>
                </Slide>

                <div className="why-text-side">
                  <ul>
                    <li className="why-text-item">
                      <div className="why-icon">
                        <img
                          src="https://res.cloudinary.com/malidad/image/upload/v1777959272/ntuna/people_pk8kje.svg"
                          alt="People Icon"
                        />
                      </div>
                      <div className="why-content">
                        <p className="why-title boldTitle ntuna-text-fill">
                          1. Expert Team
                        </p>
                        <span className="why-subtitle font-inter-regular">
                          Technology solutions are as strong as the people
                          behind them. Our team of experienced designers,
                          developers, engineers, and ICT specialists work
                          collaboratively to deliver high-quality solutions
                          tailored to the needs of modern organizations.
                        </span>
                      </div>
                    </li>
                    <li className="why-text-item">
                      <div className="why-icon">
                        <img
                          src="https://res.cloudinary.com/malidad/image/upload/v1777959273/ntuna/purpose_xqkkfk.svg"
                          alt="Computer with Mouse Icon"
                        />
                      </div>
                      <div className="why-content">
                        <p className="why-title boldTitle ntuna-text-fill">
                          2. Client-Focused Approach
                        </p>
                        <span className="why-subtitle font-inter-regular">
                          We are driven by a clear mission:{" "}
                          <span className="bold">
                            help organizations operate more efficiently using
                            technology
                          </span>
                          . From building digital platforms to deploying secure
                          ICT infrastructure, every solution is designed to
                          support productivity, innovation and growth.
                        </span>
                      </div>
                    </li>
                    <li className="why-text-item">
                      <div className="why-icon">
                        <img
                          src="https://res.cloudinary.com/malidad/image/upload/v1777959273/ntuna/process_wvxcmq.svg"
                          alt="Process Icon"
                        />
                      </div>
                      <div className="why-content">
                        <p className="why-title boldTitle ntuna-text-fill">
                          3. Proven Delivery Process
                        </p>
                        <span className="why-subtitle font-inter-regular">
                          Our structured approach from planning to deployment
                          and support ensures that every project is delivered
                          with professionalism and consistency. By combining
                          industry best practices with modern tools and
                          technologies, we deliver solutions organizations can
                          rely on.
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeWhyChooseUs;
